module.exports = __webpack_public_path__ + "assets/icon_wink_feedback.svg?v=c8a785633877d62006295678b05de517";